import { GET_PARKING_PACKS } from '@/queries';

export const getParkingPacks = async () => {

  try {
    const { data } = await useGraphQL(GET_PARKING_PACKS);

    const filteredPacks = data?.value?.data?.facilityParkingPacks?.items?.filter((pack) => pack.status === 'ACTIVE');
    const groupedPacks = filteredPacks?.reduce((acc, pack) => {
      const facility = pack.facility || {};
      const facilityName = facility.name || "Unknown Facility";

      if (!acc[facilityName]) {
        acc[facilityName] = {
          description: facility.description || "No description available",
          images: facility.images || [],
          address: facility.address?.address1,
          city: facility.address?.city,
          state: facility.address?.state,
          zip: facility.address?.zipCode,
          amenities: facility.amenities || [],
          packs: [],
        };
      }

      acc[facilityName].packs.push(pack);

      // Sort packs within each facility by displayOrder
      acc[facilityName].packs.sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));

      return acc;
    }, {});

    if (!groupedPacks) return [];

    return Object.entries(groupedPacks)
      .map(([name, data]) => ({
        name,
        ...data,
        firstDisplayOrder: data.packs.length ? data.packs[0].displayOrder || 0 : 9999,
      }))
      .sort((a, b) => a.firstDisplayOrder - b.firstDisplayOrder);

  } catch (error) {
    console.log('❌ Error getting parking packs', error);
    return [];
  }
}
